VjsAdmin.LessonsPublished = (() => {
    const $table = $('#lesson-published-table');

    const me = {
        defaultTitle: 'Manage Lesson',
        initialType: '',
    };

    const init = () => {
        initTable();
        new ManageLessons();
    };

    const resetModal = () => {
        const districtSelect2 = document.querySelector('#district-search-select2');
        districtSelect2.value = '';
        districtSelect2.dispatchEvent(new Event('change'));

        const licenseSelect2 = document.querySelector('#license-search-select2');
        licenseSelect2.value = '';
        licenseSelect2.dispatchEvent(new Event('change'));
    };

    const initSelects = (data) => {
        const districtGroup = document.querySelector('#district-search-group');
        const licenseGroup = document.querySelector('#license-search-group');
        VjsAdmin.DistrictSearchSelect.init(districtGroup, data);
        const watchDistrictSelect = true;
        VjsAdmin.LicenseSearchSelect.init(licenseGroup, data, watchDistrictSelect);
    };

    const ManageLessons = VjsUtility.Controller.extend({
        events: {
            'click .manage-lesson': 'managePopup',
            'click .vjs-popup-close-icon': 'closeModal',
            'click #add-lesson-connections': 'addLessonConnections',
            'click #remove-lesson-connection': 'removeLessonConnection',
            'click #social-awareness-checkbox': 'updateSocialAwareness',
            'click #suggested-checkbox': 'updateSuggested',
            'click #change-lesson-category': 'changeLessonCategory',
            'keyup #searchText': 'updateSearch',
            'click #built-in': 'typeBuiltIn',
            'click #built-in-state': 'typeBuiltInState',
            'click #custom': 'typeCustom',
            'change #category-select': 'checkCategorySelect',
        },

        typeBuiltIn: () => {
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#add-lesson-connections').text('Change Connection');
        },
        typeBuiltInState: () => {
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').show();
            $('#add-lesson-connections').text('Add Connection');
        },
        typeCustom: () => {
            $('#district-search-group').show();
            $('#license-search-group').show();
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#add-lesson-connections').text('Add Connection');
        },

        updateSearch: () => {
            $table.bootstrapTable('refresh');
        },

        addLessonConnections: () => {
            const selectedType = $('input[name="type"]:checked').val();
            const publishData = {
                lesson_id: me.currentLessonId,
                changeType: me.initialType !== selectedType,
                districts: $('#district-search-select2')
                    .select2('data')
                    .map((item) => ({
                        district_id: item.id,
                    })),
                licenses: $('#license-search-select2')
                    .select2('data')
                    .map((item) => ({
                        license_id: item.id,
                        district_id: item.districtId,
                    })),
                states: $('#state-search-select2')
                    .select2('data')
                    .map((item) => ({
                        state_id: item.id,
                    })),
            };

            switch (selectedType) {
                case 'built-in-state':
                    if (publishData.states.length === 0) {
                        showErrorNotification('Please select at least one state');
                        return;
                    }
                    break;
                case 'custom':
                    if (publishData.districts.length === 0 && publishData.licenses.length === 0) {
                        showErrorNotification('Please select at least one district or license');
                        return;
                    }
                    break;
                default:
                    // deafult
                    break;
            }

            const req = new VjsUtility.Request();
            req.post(Slim.Router.pathFor('content.lesson_connection.add'), publishData)
                .done((res) => {
                    const { data } = res;
                    if (
                        (data[0] === 'success' || data[0] === 'empty')
                        && (data[1] === 'success' || data[1] === 'empty')
                        && (data[2] === 'success' || data[2] === 'empty')
                    ) {
                        let notificationText = 'Successfully Added VJS Lesson Connection(s)';
                        let time = 5000;
                        if (data[3].length > 0) {
                            notificationText += `\n\nThe following connections were removed due to a parent district being added.\n${data[2].join(
                                '\n',
                            )}`;
                            time = 10000;
                        }
                        VjsUtility.Notification.success({
                            text: notificationText,
                            time,
                        });

                        $('#district-search-select2').val(null).trigger('change');
                        $('#license-search-select2').val(null).trigger('change');
                        $('#state-search-select2').val(null).trigger('change');
                        $('#lesson-connections-table').bootstrapTable('refresh');
                    } else {
                        showErrorNotification('Add Lesson Connection(s) Failed. Check Console');
                    }
                })
                .fail(() => {
                    showErrorNotification('Add Lesson Connection(s) Failed. Check Console');
                });
        },

        removeLessonConnection: (e) => {
            const publishData = {
                lesson_connection_id: $(e.currentTarget).data('lessonConnectionId'),
            };

            $.post(Slim.Router.pathFor('content.lesson_connection.remove'), publishData)
                .done((res) => {
                    if (res.data === 'success') {
                        VjsUtility.Notification.success({
                            text: 'Successfully Removed Lesson Connection',
                            time: 3000,
                        });

                        $('#lesson-connections-table').bootstrapTable('refresh');
                    } else {
                        showErrorNotification('Remove Lesson Connection Failed Check Console');
                    }
                })
                .fail(() => {
                    showErrorNotification('Remove Lesson Connection Failed Check Console');
                });
        },

        changeLessonCategory: () => {
            const publishData = {
                lesson_id: me.currentLessonId,
                categories: $('#category-select')
                    .select2('data')
                    .map((item) => ({
                        category: item.id,
                    })),
            };

            $.post(Slim.Router.pathFor('content.lessons.change_category'), publishData)
                .done((res) => {
                    if (res.data === 'success') {
                        VjsUtility.Notification.success({
                            text: 'Successfully Changed Lesson Category',
                            time: 3000,
                        });

                        $('#lesson-published-table').bootstrapTable('refresh');
                    } else {
                        showErrorNotification('Change Lesson Category Failed Check Console');
                    }
                })
                .fail(() => {
                    showErrorNotification('Change Lesson Category Failed Check Console');
                });
        },

        checkCategorySelect: () => {
            const categories = $('#category-select').select2('data');

            if (categories.length > 0) {
                $('#change-lesson-category').prop('disabled', false);
            } else {
                $('#change-lesson-category').prop('disabled', true);
            }
        },

        updateSocialAwareness: () => {
            const checkbox = $('#social-awareness-checkbox');
            checkbox.prop('disabled', true);
            const publishData = {
                lesson_id: me.currentLessonId,
                social_awareness: $('#social-awareness-checkbox').is(':checked'),
            };
            $.post(Slim.Router.pathFor('content.lessons.update_social_awareness'), publishData)
                .done((res) => {
                    if (res.status === 'success') {
                        VjsUtility.Notification.success({
                            text: 'Successfully Updated Social Awareness Setting',
                            time: 3000,
                        });

                        $('#lesson-published-table').bootstrapTable('refresh');
                    } else {
                        showErrorNotification('Update Social Awareness Setting Failed Check Console');
                    }
                })
                .fail(() => {
                    showErrorNotification('Update Social Awareness Setting Failed Check Console');
                })
                .always(() => {
                    checkbox.prop('disabled', false);
                });
        },

        updateSuggested: () => {
            const checkbox = $('#suggested-checkbox');
            checkbox.prop('disabled', true);

            const publishData = {
                lesson_id: me.currentLessonId,
                is_suggested: $('#suggested-checkbox').is(':checked'),
            };
            $.post(Slim.Router.pathFor('content.lessons.update_suggested'), publishData)
                .done((res) => {
                    if (res.status === 'success') {
                        VjsUtility.Notification.success({
                            text: 'Successfully Updated Suggested Lesson Setting',
                            time: 3000,
                        });

                        $('#lesson-published-table').bootstrapTable('refresh');
                    } else {
                        showErrorNotification('Update Suggested Lesson Setting Failed Check Console');
                    }
                })
                .fail(() => {
                    showErrorNotification('Update Suggested Lesson Setting Failed Check Console');
                })
                .always(() => {
                    checkbox.prop('disabled', false);
                });
        },

        closeModal: () => {
            resetModal();
        },

        managePopup: (e) => {
            me.currentLessonName = $(e.currentTarget).data('lessonName');
            me.currentLessonId = $(e.currentTarget).data('lessonId');
            me.socialAwareness = $(e.currentTarget).data('socialAwareness') === 1;
            me.isSuggested = $(e.currentTarget).data('isSuggested') === 1;
            const rawData = $(e.currentTarget).data('lessonCategories');
            const decodedData = decodeURIComponent(rawData || '[]');
            me.lessonCategories = JSON.parse(decodedData);
            VjsUtility.Popup.init({
                title: `${me.defaultTitle}: ${me.currentLessonName}`,
                templateUrl: '/assets/templates/content/lesson-manage-modal.html',
                after() {
                    // "Change Lesson Category" button is disabled until at least one category is selected.
                    $('#change-lesson-category').prop('disabled', true);

                    const districtGroup = document.querySelector('#district-search-group');
                    const licenseGroup = document.querySelector('#license-search-group');
                    const stateGroup = document.querySelector('#state-search-group');
                    const cetegorySelectGroup = document.querySelector('#flexlesson-categories');
                    VjsAdmin.DistrictSearchSelect.init(districtGroup);
                    const watchDistrictSelect = true;
                    VjsAdmin.LicenseSearchSelect.init(licenseGroup, watchDistrictSelect);
                    VjsAdmin.StateSearchSelect.init(stateGroup, []);
                    VjsAdmin.CategorySelect.init(cetegorySelectGroup, []);
                    initLessonConnectionTable(me.currentLessonId);

                    // Set the lesson categories in the dropdown
                    if (me.lessonCategories && me.lessonCategories.length > 0) {
                        const categoryValues = me.lessonCategories.map((cat) => cat.category);
                        $('#category-select').val(categoryValues).trigger('change');
                    }

                    // Set the social awareness checkbox
                    $('#social-awareness-checkbox').prop('checked', me.socialAwareness).trigger('change');
                    $('#suggested-checkbox').prop('checked', me.isSuggested).trigger('change');
                },
            });
        },
    });

    const showErrorNotification = (text) => {
        VjsUtility.Notification.error({
            text,
            time: 5000,
        });
    };

    const initTable = () => {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#lesson-drafts-table',
            queryParams: (params) => {
                const myParams = {};
                const searchTerm = document.querySelector('#searchText').value;

                if (typeof params !== 'undefined') {
                    myParams.search_term = searchTerm;
                    myParams.page = params.pageNumber;
                    myParams.page_size = params.pageSize;
                    myParams.sortOrder = params.sortOrder;
                } else {
                    myParams.search_term = searchTerm;
                    myParams.page = 1;
                    myParams.page_size = 25;
                    myParams.sortOrder = 'desc';
                }

                return myParams;
            },

            search: false, // disabled because a custom toolbar for search is being used thanks to an issue with two bootstrap-tables on one
            formatNoMatches: () => 'No Lessons Found',
            toolbar: '#filters',
            toolbarAlign: 'left',

            url: Slim.Router.pathFor('content.lessons.get'),
            columns: [
                {
                    title: 'Lesson ID',
                    field: 'id',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Lesson Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Creator',
                    field: 'creator',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => `${val?.user_name}`.trim(),
                },
                {
                    title: 'Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => new Date(val).toLocaleDateString('en-US'),
                },
                {
                    title: 'Released/Scheduled',
                    field: 'date_published',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => new Date(val).toLocaleDateString('en-US'),
                },
                {
                    title: 'Explore Plus',
                    field: 'is_premium',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => (val === '1' ? 'Yes' : 'No'),
                },
                {
                    title: 'Categories',
                    field: 'lesson_categories',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (data) => Object.entries(data).map(([key, val]) => ` ${val.category}`),
                },
                {
                    title: 'Suggested',
                    field: 'is_suggested',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => (val === '1' ? '<div class="text-success">✓</div>' : '<div class="text-danger">✗</div>'),
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val, row) => `
                            <button
                                class="btn btn-primary manage-lesson"
                                data-lesson-id="${row.id}"
                                data-lesson-name="${row.name}"
                                data-social-awareness="${row.social_awareness}"
                                data-is-suggested="${row.is_suggested}"
                                data-lesson-categories="${encodeURIComponent(JSON.stringify(row.lesson_categories))}"
                            >
                                Manage
                            </button>`,
                },
            ],
            responseHandler: (res) => {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;
                return formattedResult;
            },
        });
    };

    const disableRadios = (disable = true) => {
        $('#built-in').attr('disabled', disable);
        $('#built-in-state').attr('disabled', disable);
        $('#custom').attr('disabled', disable);
    };

    const initLessonConnectionTable = (lessonId) => {
        disableRadios();

        $('#lesson-connections-table').bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#lesson-connections-table',
            formatNoMatches: () => 'No Lesson Connections Found',
            url: Slim.Router.pathFor('content.lesson_connection.get'),
            pageSize: 999999,
            columns: [
                {
                    title: 'District',
                    field: 'district_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val, row) => {
                        if (val) {
                            return `${row.districts.district_name} (${val})`;
                        }
                        return 'No District Associated';
                    },
                },
                {
                    title: 'License',
                    field: 'license_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val, row) => {
                        if (val) {
                            return `${row.licenses.license_name} (${val})`;
                        }
                        return 'No License Associated';
                    },
                },
                {
                    title: 'State',
                    field: 'state',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => {
                        if (val) {
                            return `${val}`;
                        }
                        return 'No State Associated';
                    },
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val, row) => `
                            <button
                                id="remove-lesson-connection"
                                class="btn btn-primary"
                                data-lesson-connection-id="${row.id}"
                            >
                                Remove Connection
                            </button>`,
                },
            ],
            queryParams: (params) => {
                params.lesson_id = lessonId;
                return params;
            },
            responseHandler: (res) => {
                initSelects(res.data);
                disableRadios(false);
                setType(res.data);
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
        });
    };

    const setType = (data) => {
        if (data.length === 0) {
            $('#built-in').attr('checked', true).trigger('change');
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#add-lesson-connections').text('Change Connection');
            me.initialType = 'built-in';
        } else if (data[0].state !== null) {
            $('#built-in-state').attr('checked', true).trigger('change');
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').show();
            $('#add-lesson-connections').text('Add Connection');
            me.initialType = 'built-in-state';
        } else {
            $('#custom').attr('checked', true).trigger('change');
            $('#district-search-group').show();
            $('#license-search-group').show();
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#add-lesson-connections').text('Add Connection');
            me.initialType = 'custom';
        }
    };

    return {
        init,
    };
})();
